import { http } from '@/api/http';
import { ApiResponseBody } from '@/api/types';
import { Case, getCaseApiUrl } from '@/api/apis/case';
import { RandomizationClinicalData } from '@/api/apis/cases/clinical-data/clinical-data.types';

const randomizationClinicalData = async (caseId: string, data: RandomizationClinicalData) => {
  const res = await http.post<ApiResponseBody<Case>>(getCaseApiUrl.randomizationClinicalData(caseId), data);

  return res.data.data;
};

export const clinicalDataFetcher = {
  randomizationClinicalData,
};
